export default __webpack_public_path__ + "static/media/banner-3.a6212b8c.jpg";